export default __webpack_public_path__ + "static/media/aocaboteatro13.fe897155.jpg";